import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { setupAnalytics } from './lib/analytics';
import { setupClarity } from './lib/clarity';

// Initialize Microsoft Clarity
setupClarity();

// Initialize Google Analytics
setupAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
